var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$emit('showHint')}}},[_vm._v(" mdi-help-circle-outline ")])
}
var staticRenderFns = []

export { render, staticRenderFns }